/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GameModelDto } from '../../models/game-model-dto';

export interface ScoutingControllerGetTeamGamesWithVideo$Params {
  teamUuid: string;
}

export function scoutingControllerGetTeamGamesWithVideo(http: HttpClient, rootUrl: string, params: ScoutingControllerGetTeamGamesWithVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GameModelDto>>> {
  const rb = new RequestBuilder(rootUrl, scoutingControllerGetTeamGamesWithVideo.PATH, 'get');
  if (params) {
    rb.path('teamUuid', params.teamUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GameModelDto>>;
    })
  );
}

scoutingControllerGetTeamGamesWithVideo.PATH = '/scouting/{teamUuid}/games';
